import { render, staticRenderFns } from "./CustomDDMenu.vue?vue&type=template&id=29f7cd06&"
import script from "./CustomDDMenu.vue?vue&type=script&lang=ts&"
export * from "./CustomDDMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports